import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import Description from './Description';

const queryClient = new QueryClient();

export interface TopicProps {
  entityId?: number;
  topicName: string;
  withGrid: boolean;
}

const TopicDescription = ({ entityId, topicName, withGrid }: TopicProps) => {
  return (
    <QueryClientProvider client={queryClient}>
      <Description withGrid={withGrid} entityId={entityId} topicName={topicName} />
    </QueryClientProvider>
  );
};

export default TopicDescription;
